import { useTranslation } from '@/i18n';
import { AmbaAlertPropsType, AmbaAlertTypes } from '@/models/globalModels';

import { Shown } from './Shown';

export const AmbaAlert = ({
  type = AmbaAlertTypes.NOTIFICATION,
  alertMessage = '',
  showAlert = false,
  showIcon,
  ariaDescribedBy,
  isLink = false,
  isDismiss = false,
  linkUrl,
  data,
}: AmbaAlertPropsType) => {
  const { t } = useTranslation('auth');

  if (data?.reset_password_link) {
    return (
      <Shown>
        <div className="AmbaAlert">
          <div className={`alert fade show alert-${type} ${isDismiss ? 'alert-dismissible' : ''}`} role="alert">
            {alertMessage}
            <a className="mx-2" href={data.reset_password_link}>
              {t('clickHereResetPassword')}
            </a>
          </div>
        </div>
      </Shown>
    );
  }

  return (
    <>
      {showAlert ? (
        <Shown>
          <div className="AmbaAlert">
            {/* TODO: Implement svg bootstrap icons to illustrate alerts & dismissable alert */}
            {/* TODO: Improve dissmisible parameter, currently it won't show again if dismissed */}
            {/* <svg className="bi flex-shrink-0 me-2" role="img" aria-label="Info:">
              <use xlinkHref="#info-fill"/>
            </svg> */}
            <div className={`alert fade show alert-${type} ${isDismiss ? 'alert-dismissible' : ''}`} role="alert">
              {alertMessage}
              {isDismiss ? <button aria-label={t('common:btnClose')} className="btn-close" data-bs-dismiss="alert" type="button" /> : null}
            </div>
          </div>
        </Shown>
      ) : null}
    </>
  );
};
